export default __webpack_public_path__ + "static/media/k.911ce22e.svg";